import React from 'react';
import { Logo } from '../components/Logo';
import { ArrowLeftIcon } from 'lucide-react';
export function BrandBook() {
  const blues = [{
    name: 'blue-200',
    hex: '#BFDBFE',
    class: 'bg-blue-200'
  }, {
    name: 'blue-300',
    hex: '#93C5FD',
    class: 'bg-blue-300'
  }, {
    name: 'blue-400',
    hex: '#60A5FA',
    class: 'bg-blue-400'
  }, {
    name: 'blue-500',
    hex: '#3B82F6',
    class: 'bg-blue-500'
  }, {
    name: 'blue-600',
    hex: '#2563EB',
    class: 'bg-blue-600'
  }];
  const grays = [{
    name: 'gray-900',
    hex: '#111827',
    class: 'bg-gray-900'
  }, {
    name: 'gray-700',
    hex: '#374151',
    class: 'bg-gray-700'
  }, {
    name: 'gray-600',
    hex: '#4B5563',
    class: 'bg-gray-600'
  }, {
    name: 'gray-500',
    hex: '#6B7280',
    class: 'bg-gray-500'
  }, {
    name: 'gray-400',
    hex: '#9CA3AF',
    class: 'bg-gray-400'
  }, {
    name: 'gray-200',
    hex: '#E5E7EB',
    class: 'bg-gray-200'
  }, {
    name: 'gray-100',
    hex: '#F3F4F6',
    class: 'bg-gray-100'
  }];
  return <div className="min-h-screen bg-gray-50" data-id="element-338">
      {/* Header */}
      <header className="sticky top-0 z-10 bg-white border-b border-gray-200" data-id="element-339">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-340">
          <div className="flex items-center gap-3" data-id="element-341">
            <Logo showText={false} size="sm" data-id="element-342" />
            <span className="text-sm font-medium text-gray-900" data-id="element-343">
              Obra Digital — Brand Book
            </span>
          </div>
          <a href="#" onClick={e => {
          e.preventDefault();
          window.location.hash = '';
          window.location.reload();
        }} className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors" data-id="element-344">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-345" />
            Volver al sitio
          </a>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-12 space-y-16" data-id="element-346">
        {/* Logo Section */}
        <section data-id="element-347">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-348">Logo</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-349">
            Versiones del logo para diferentes contextos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-350">
            {/* Logo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-351">
              <Logo showText={true} size="lg" variant="dark" data-id="element-352" />
            </div>
            {/* Logo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-353">
              <Logo showText={true} size="lg" variant="light" data-id="element-354" />
            </div>
            {/* Isotipo on white */}
            <div className="bg-white rounded-2xl border border-gray-200 p-10 flex items-center justify-center" data-id="element-355">
              <Logo showText={false} size="lg" variant="dark" data-id="element-356" />
            </div>
            {/* Isotipo on dark */}
            <div className="bg-[#111827] rounded-2xl p-10 flex items-center justify-center" data-id="element-357">
              <Logo showText={false} size="lg" variant="light" data-id="element-358" />
            </div>
          </div>

          {/* Size variants */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-359">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-360">
              Tamaños
            </p>
            <div className="flex items-end gap-10" data-id="element-361">
              <div className="text-center" data-id="element-362">
                <Logo showText={true} size="sm" variant="dark" data-id="element-363" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-364">sm</span>
              </div>
              <div className="text-center" data-id="element-365">
                <Logo showText={true} size="md" variant="dark" data-id="element-366" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-367">md</span>
              </div>
              <div className="text-center" data-id="element-368">
                <Logo showText={true} size="lg" variant="dark" data-id="element-369" />
                <span className="text-xs text-gray-400 mt-3 block" data-id="element-370">lg</span>
              </div>
            </div>
          </div>

          <div className="mt-6 grid grid-cols-2 gap-4 text-sm text-gray-500" data-id="element-371">
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-372">
              <span className="font-medium text-gray-700" data-id="element-373">Espacio mínimo</span>
              <p className="text-xs mt-1" data-id="element-374">
                Mantener al menos 1x el ancho del isotipo como margen.
              </p>
            </div>
            <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-375">
              <span className="font-medium text-gray-700" data-id="element-376">No distorsionar</span>
              <p className="text-xs mt-1" data-id="element-377">
                Nunca estirar, rotar o cambiar los colores del logo.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-378" />

        {/* Color Palette */}
        <section data-id="element-379">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-380">Colores</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-381">
            Paleta de colores de la marca.
          </p>

          {/* Primary */}
          <div className="mb-8" data-id="element-382">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-383">
              Primario
            </p>
            <div className="flex items-start gap-4" data-id="element-384">
              <div className="w-24 h-24 rounded-xl bg-blue-600 shadow-sm" data-id="element-385" />
              <div data-id="element-386">
                <p className="font-semibold text-gray-900" data-id="element-387">Blue 600</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-388">#2563EB</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-389">bg-blue-600</p>
              </div>
            </div>
          </div>

          {/* Blue scale */}
          <div className="mb-8" data-id="element-390">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-391">
              Escala de azules
            </p>
            <div className="flex gap-3" data-id="element-392">
              {blues.map(color => <div key={color.name} className="text-center" data-id="element-393">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm`} data-id="element-394" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-395">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-396">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Gray scale */}
          <div className="mb-8" data-id="element-397">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-398">
              Escala de grises
            </p>
            <div className="flex gap-3" data-id="element-399">
              {grays.map(color => <div key={color.name} className="text-center" data-id="element-400">
                  <div className={`w-14 h-14 rounded-lg ${color.class} shadow-sm border border-gray-200`} data-id="element-401" />
                  <p className="text-[10px] text-gray-500 mt-2 font-mono" data-id="element-402">
                    {color.hex}
                  </p>
                  <p className="text-[10px] text-gray-400" data-id="element-403">{color.name}</p>
                </div>)}
            </div>
          </div>

          {/* Dark background */}
          <div data-id="element-404">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-405">
              Fondo oscuro
            </p>
            <div className="flex items-start gap-4" data-id="element-406">
              <div className="w-24 h-24 rounded-xl bg-[#111827] shadow-sm" data-id="element-407" />
              <div data-id="element-408">
                <p className="font-semibold text-gray-900" data-id="element-409">Dark</p>
                <p className="text-sm text-gray-500 font-mono" data-id="element-410">#111827</p>
                <p className="text-xs text-gray-400 mt-1" data-id="element-411">bg-[#111827]</p>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-412" />

        {/* Typography */}
        <section data-id="element-413">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-414">Tipografía</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-415">
            Inter — La fuente principal de la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-416">
            <div data-id="element-417">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-418">
                H1 — text-4xl font-extrabold
              </span>
              <h1 className="text-4xl font-extrabold text-gray-900" data-id="element-419">
                Nunca más pierdas registro
              </h1>
            </div>
            <div data-id="element-420">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-421">
                H2 — text-3xl font-bold
              </span>
              <h2 className="text-3xl font-bold text-gray-900" data-id="element-422">
                Precio simple y transparente
              </h2>
            </div>
            <div data-id="element-423">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-424">
                H3 — text-2xl font-bold
              </span>
              <h3 className="text-2xl font-bold text-gray-900" data-id="element-425">
                El caos de la información
              </h3>
            </div>
            <div data-id="element-426">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-427">
                H4 — text-xl font-semibold
              </span>
              <h4 className="text-xl font-semibold text-gray-900" data-id="element-428">
                Así de simple
              </h4>
            </div>
            <hr className="border-gray-100" data-id="element-429" />
            <div data-id="element-430">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-431">
                Body — text-base text-gray-600
              </span>
              <p className="text-base text-gray-600" data-id="element-432">
                Centraliza todas las fotos de obra automáticamente desde
                WhatsApp. Sin apps nuevas, sin fricción.
              </p>
            </div>
            <div data-id="element-433">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-434">
                Small — text-sm text-gray-500
              </span>
              <p className="text-sm text-gray-500" data-id="element-435">
                Menos del 0,1% del presupuesto total de una obra promedio.
              </p>
            </div>
            <div data-id="element-436">
              <span className="text-xs text-gray-400 block mb-2" data-id="element-437">
                Caption — text-xs text-gray-400
              </span>
              <p className="text-xs text-gray-400" data-id="element-438">
                © 2026 Obra Digital. Todos los derechos reservados.
              </p>
            </div>
          </div>

          {/* Font weights */}
          <div className="mt-6 bg-white rounded-2xl border border-gray-200 p-8" data-id="element-439">
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-440">
              Pesos de fuente
            </p>
            <div className="space-y-4" data-id="element-441">
              <div className="flex items-baseline gap-4" data-id="element-442">
                <span className="w-24 text-xs text-gray-400" data-id="element-443">400 Regular</span>
                <span className="font-normal text-gray-900" data-id="element-444">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-445">
                <span className="w-24 text-xs text-gray-400" data-id="element-446">500 Medium</span>
                <span className="font-medium text-gray-900" data-id="element-447">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-448">
                <span className="w-24 text-xs text-gray-400" data-id="element-449">600 Semibold</span>
                <span className="font-semibold text-gray-900" data-id="element-450">
                  Obra Digital
                </span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-451">
                <span className="w-24 text-xs text-gray-400" data-id="element-452">700 Bold</span>
                <span className="font-bold text-gray-900" data-id="element-453">Obra Digital</span>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-454">
                <span className="w-24 text-xs text-gray-400" data-id="element-455">
                  800 Extrabold
                </span>
                <span className="font-extrabold text-gray-900" data-id="element-456">
                  Obra Digital
                </span>
              </div>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-457" />

        {/* Buttons */}
        <section data-id="element-458">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-459">Botones</h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-460">
            Estilos de botones utilizados en la marca.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-8" data-id="element-461">
            {/* Primary */}
            <div data-id="element-462">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-463">
                Primario
              </p>
              <div className="flex items-center gap-4" data-id="element-464">
                <button className="px-4 py-2 text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-465">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-466">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-white bg-blue-600 hover:bg-blue-700 rounded-xl transition-colors" data-id="element-467">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-468">
                bg-blue-600 text-white rounded-xl
              </p>
            </div>

            {/* Secondary */}
            <div data-id="element-469">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-470">
                Secundario
              </p>
              <div className="flex items-center gap-4" data-id="element-471">
                <button className="px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-472">
                  Pequeño
                </button>
                <button className="px-5 py-2.5 text-base font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-473">
                  Mediano
                </button>
                <button className="px-6 py-3 text-lg font-semibold text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 rounded-xl transition-colors" data-id="element-474">
                  Grande
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-475">
                border border-gray-300 text-gray-700 bg-white rounded-xl
              </p>
            </div>

            {/* Ghost */}
            <div data-id="element-476">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4" data-id="element-477">
                Ghost / Texto
              </p>
              <div className="flex items-center gap-4" data-id="element-478">
                <button className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors" data-id="element-479">
                  Enlace de texto
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-3 font-mono" data-id="element-480">
                text-blue-600 hover:text-blue-700
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-481" />

        {/* Text Colors */}
        <section data-id="element-482">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-483">
            Grises de texto
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-484">
            Colores de texto para diferentes jerarquías.
          </p>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 space-y-6" data-id="element-485">
            <div data-id="element-486">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-487">
                text-gray-900
              </span>
              <p className="text-gray-900" data-id="element-488">
                Texto principal, títulos y encabezados importantes.
              </p>
            </div>
            <div data-id="element-489">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-490">
                text-gray-700
              </span>
              <p className="text-gray-700" data-id="element-491">
                Texto secundario con buena legibilidad.
              </p>
            </div>
            <div data-id="element-492">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-493">
                text-gray-600
              </span>
              <p className="text-gray-600" data-id="element-494">
                Texto de cuerpo estándar para párrafos.
              </p>
            </div>
            <div data-id="element-495">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-496">
                text-gray-500
              </span>
              <p className="text-gray-500" data-id="element-497">
                Texto de apoyo y descripciones secundarias.
              </p>
            </div>
            <div data-id="element-498">
              <span className="text-xs text-gray-400 block mb-1" data-id="element-499">
                text-gray-400
              </span>
              <p className="text-gray-400" data-id="element-500">
                Texto sutil, captions y metadatos.
              </p>
            </div>
          </div>
        </section>

        <hr className="border-gray-200" data-id="element-501" />

        {/* Spacing & Radius */}
        <section data-id="element-502">
          <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-503">
            Espaciado y Bordes
          </h2>
          <p className="text-sm text-gray-500 mb-8" data-id="element-504">
            Valores de espaciado y radio de borde comunes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-505">
            {/* Border radius */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-506">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-507">
                Border Radius
              </p>
              <div className="flex items-end gap-4" data-id="element-508">
                <div className="text-center" data-id="element-509">
                  <div className="w-12 h-12 bg-blue-100 rounded-md" data-id="element-510" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-511">
                    rounded-md
                  </span>
                </div>
                <div className="text-center" data-id="element-512">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg" data-id="element-513" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-514">
                    rounded-lg
                  </span>
                </div>
                <div className="text-center" data-id="element-515">
                  <div className="w-12 h-12 bg-blue-100 rounded-xl" data-id="element-516" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-517">
                    rounded-xl
                  </span>
                </div>
                <div className="text-center" data-id="element-518">
                  <div className="w-12 h-12 bg-blue-100 rounded-2xl" data-id="element-519" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-520">
                    rounded-2xl
                  </span>
                </div>
                <div className="text-center" data-id="element-521">
                  <div className="w-12 h-12 bg-blue-100 rounded-full" data-id="element-522" />
                  <span className="text-[10px] text-gray-400 mt-2 block" data-id="element-523">
                    rounded-full
                  </span>
                </div>
              </div>
            </div>

            {/* Spacing */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8" data-id="element-524">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-6" data-id="element-525">
                Padding
              </p>
              <div className="space-y-3" data-id="element-526">
                <div className="flex items-center gap-3" data-id="element-527">
                  <div className="bg-blue-600 p-2 rounded" data-id="element-528">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-529" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-530">p-2 (8px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-531">
                  <div className="bg-blue-600 p-4 rounded" data-id="element-532">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-533" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-534">p-4 (16px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-535">
                  <div className="bg-blue-600 p-6 rounded" data-id="element-536">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-537" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-538">p-6 (24px)</span>
                </div>
                <div className="flex items-center gap-3" data-id="element-539">
                  <div className="bg-blue-600 p-8 rounded" data-id="element-540">
                    <div className="w-4 h-4 bg-white rounded-sm" data-id="element-541" />
                  </div>
                  <span className="text-xs text-gray-500" data-id="element-542">p-8 (32px)</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <div className="text-center pt-8 pb-4" data-id="element-543">
          <p className="text-xs text-gray-400" data-id="element-544">
            Obra Digital Brand Book — Uso interno
          </p>
        </div>
      </main>
    </div>;
}